import { render, staticRenderFns } from "./advertising2.vue?vue&type=template&id=17f2f500&scoped=true&"
import script from "./advertising2.vue?vue&type=script&lang=js&"
export * from "./advertising2.vue?vue&type=script&lang=js&"
import style0 from "./advertising2.vue?vue&type=style&index=0&id=17f2f500&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f2f500",
  null
  
)

export default component.exports